export const UPDATE_INFO = 'UPDATE_INFO';
export const UPDATE_CART = 'UPDATE_CART';
export const UPDATE_PRODUCT = 'UPDATE_PRODUCT';
export const UPDATE_NEW_PRODUCT = 'UPDATE_NEW_PRODUCT';
export const BASE_STATE = 'BASE_STATE';
export const RESTORE = 'RESTORE';
export const FOLOOSI_PRODUCTS = 'FOLOOSI_PRODUCTS';
export const UPDATE_LIST = 'UPDATE_LIST';
export const UPDATE_LIKE_LIST = 'UPDATE_LIKE_LIST';